module.exports = __webpack_public_path__ + "img/main.3483d862.png";